export const Title = (title) => document.title = `${process.env.REACT_APP_NAME} | ${title}`
